import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, recruitmentsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, recruitmentsActions);

export default slice.reducer;
